<template>
    <div
        class="ui inverted menu"
        style="
            border-radius: 0px;
            margin: 0 !important;
            width: 100%;
            top: 0;
            position: fixed;
            z-index: 1000;
        "
    >
        <sui-menu-item @click="toggleSidebar()" class="mobile">
            <sui-icon name="bars" style="font-size: 20px; margin: 0" />
        </sui-menu-item>
        <sui-menu-item class="mobile" style="font-weight: bold">
            {{ page_title }} Admin
        </sui-menu-item>
        <template v-for="i in NAVBAR_ITEMS">
            <sui-menu-item
                v-if="!i.items || i.items.length == 0"
                @click="i.onClick()"
                class="desktop"
            >
                {{ i.text }}
                <sui-label
                    color="red"
                    size="mini"
                    v-if="i.badge && i.badge > 0"
                    style="margin-left: 5px"
                    >{{ i.badge }}</sui-label
                >
            </sui-menu-item>
            <sui-dropdown
                class="desktop"
                v-if="i.items && i.items.length > 0"
                item
                :text="i.text"
            >
                <sui-label
                    color="red"
                    size="mini"
                    v-if="i.badge && i.badge > 0"
                    style="margin-left: 5px"
                    >{{ i.badge }}</sui-label
                >
                <sui-dropdown-menu>
                    <sui-menu-item v-for="j in i.items" @click="j.onClick()">
                        {{ j.text }}
                        <sui-label
                            color="red"
                            size="mini"
                            v-if="j.badge > 0"
                            style="margin-left: 5px"
                            >{{ j.badge }}</sui-label
                        >
                    </sui-menu-item>
                </sui-dropdown-menu>
            </sui-dropdown>
        </template>
        <SuiMenuItem position="right" as="div">
            <SuiButton size="mini" color="olive" @click="createOrder"
                >Crear pedido</SuiButton
            >
        </SuiMenuItem>
        <sui-menu-menu position="right" style="width: fit-content !important">
            <sui-dropdown item :text="userName" class="desktop">
                <sui-dropdown-menu>
                    <sui-menu-item @click="sellerClients()"
                        >Mis Clientes</sui-menu-item
                    >
                    <sui-menu-item @click="debt()">Mis Deudas</sui-menu-item>
                    <sui-menu-item v-if="canAccessClientFocus" @click="clientFocus()">Enfoque de clientes</sui-menu-item>
                    <sui-menu-item @click="tutorials()"> Ayuda </sui-menu-item>
                    <sui-menu-item @click="logout()"
                        >Cerrar Sesión</sui-menu-item
                    >
                </sui-dropdown-menu>
            </sui-dropdown>
        </sui-menu-menu>
    </div>
</template>

<script>
    import { ref, computed, inject } from "vue";
    import { useRouter } from "vue-router";
    import { decryptData } from "../../../Util";
    import Api from "../../api/Api";
    import SystemConfiguration from "../../management/SystemConfiguration.vue";

    export default {
        setup() {
            const router = useRouter();
            const adminType = decryptData(localStorage.getItem("adminType"));
            const userName = ref(decryptData(localStorage.getItem("user")));
            const count = inject("count");
            const sidebar = inject("sidebar");
            const toggleSidebarP = inject("toggleSidebar");
            let userPermissions = decryptData(localStorage.getItem("permissions"));
            userPermissions = userPermissions
                ? userPermissions.split(",").map(Number)
                : [];
            const page_title = process.env.VUE_APP_CLIENT_NAME;

            const pushRouter = (page) => {
                sidebar.value = false;
                router.push({ name: page });
            };

            const logout = async () => {
                localStorage.clear();
                Api.logout();
                pushRouter("Login");
            };

            const users = async () => {
                return pushRouter("Users");
            };

            const home = async () => {
                return pushRouter("Home");
            };

            const products = async () => {
                return pushRouter("Products");
            };

            const clients = async () => {
                return pushRouter("Clients");
            };

            const groups = async () => {
                return pushRouter("Groups");
            };

            const clientProspects = async () => {
                return pushRouter("ClientsProspects");
            };

            const salesFunnel = async () => {
                return pushRouter("SalesFunnel");
            };

            const clientTypes = async () => {
                return pushRouter("ClientTypes");
            };

            const clientOrders = async () => {
                return pushRouter("ClientsOrders");
            };
            const createOrder = async () => {
                return pushRouter("CreateOrder");
            };
            const clientsSalesMap = async () => {
                return pushRouter("ClientsSalesMap");
            };

            const routes = async () => {
                return pushRouter("Routes");
            };

            const ranges = async () => {
                return pushRouter("Ranges");
            };

            const productTypes = async () => {
                return pushRouter("ProductTypes");
            };

            const productMetadata = async () => {
                return pushRouter("ProductMetadata");
            };

            const productPresentations = async () => {
                return pushRouter("ProductUnits");
            };

            const suppliers = async () => {
                return pushRouter("Suppliers");
            };

            const warehouses = async () => {
                return pushRouter("Warehouses");
            };

            const runs = async () => {
                return pushRouter("Runs");
            };

            const orders = async () => {
                return pushRouter("Orders");
            };

            const sellerClients = async () => {
                return pushRouter("SellerClients");
            };

            const clientsReport = async () => {
                return pushRouter("ClientsReport");
            };

            const promotions = async () => {
                return pushRouter("Promotions");
            };

            const promotionsCreate = async () => {
                return pushRouter("CreatePromotions");
            };

            const promotionsList = async () => {
                return pushRouter("ListPromotions");
            };

            const sales = async () => {
                return pushRouter("Sales");
            };

            const salesReport = async () => {
                return pushRouter("SalesReport");
            };

            const debt = async () => {
                return pushRouter("DebtReport");
            };

            const debts = async () => {
                return pushRouter("DebtReport");
            };

            const clientFocus = async () => {
                return pushRouter("ClientFocus");
            };

            const ordersDebt = async () => {
                return pushRouter("OrdersDebt");
            };

            const comissions = async () => {
                return pushRouter("Comissions");
            };

            const priceList = async () => {
                return pushRouter("PriceList");
            };

            const tridimensionalReport = async () => {
                return pushRouter("TridimensionalReport");
            };

            const paymentReport = async () => {
                return pushRouter("PaymentsReport");
            };

            const paymentsReconciliationReport = async () => {
                return pushRouter("PaymentsReconciliationReport");
            };

            const expenses = async () => {
                return pushRouter("Expenses");
            };

            const expenseCategories = async () => {
                return pushRouter("ExpenseCategories");
            };

            const dashboard = async () => {
                return pushRouter("Dashboard");
            };

            const multiPaymentProcessor = async () => {
                return pushRouter("MultiPaymentProcessor");
            };

            const inventoryReport = async () => {
                return pushRouter("InventoryReport");
            };

            const accountingInvoicesReport = async () => {
                return pushRouter("AccountingInvoicesReport");
            };

            const accountingModule = async () => {
                return pushRouter("AccountingModule");
            };

            const systemConfiguration = async () => {
                return pushRouter("Configuration");
            };

            const tutorials = async () => {
                return pushRouter("Tutorials");
            };

            const iconsMenu = async () => {
                return pushRouter("MenuIcons");
            };

            const biMenu = async () => {
                return pushRouter("BusinessInteligenceMenu");
            };

            const canAccessClientFocus =
                adminType == 12 ||
                userPermissions.includes(2029) ||
                userPermissions.includes("2029");

            const NAVBAR_ITEMS = computed(() => {
                const adminMenuPermissions = [1001, 1002, 1003, 2028];
                const productsMenuPermissions = [
                    3000, 3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008, 3009,
                ];
                const clientsMenuPermissions = [
                    2001, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011,
                ];
                const warehousesMenuPermissions = [
                    5000, 5001, 5002, 5003, 5004, 5005,
                ];
                const suppliersMenuPermissions = [
                    6000, 6001, 6002, 6003, 6004, 6005, 6006, 6007, 6008, 6009,
                    6010, 6011, 6012, 6013, 6014,
                ];
                const productMenuActivate = productsMenuPermissions.some(
                    (seachPermit) => userPermissions.includes(seachPermit)
                );
                const adminMenuActivate = adminMenuPermissions.some(
                    (seachPermit) => userPermissions.includes(seachPermit)
                );
                // Reports module gate: "Ver modulo reportes" (1008) is required.
                const reportsMenuActivate = userPermissions.includes(1008);
                const warehousesMenuActivate = warehousesMenuPermissions.some(
                    (seachPermit) => userPermissions.includes(seachPermit)
                );
                const suppliersMenuActivate = suppliersMenuPermissions.some(
                    (seachPermit) => userPermissions.includes(seachPermit)
                );

                const filteredItems = [
                    {
                        text: "Menu",
                        onClick: iconsMenu,
                    },
                    ...(adminMenuActivate ||
                    userPermissions.includes(2028) ||
                    userPermissions.includes("2028") ||
                    adminType == 12
                        ? [
                              {
                                  text: "Admin",
                                  items: [
                                      ...(adminType == 12
                                          ? [
                                                {
                                                    text: "Configuración del sistema",
                                                    onClick:
                                                        systemConfiguration,
                                                },
                                            ]
                                          : []),
                                      ...(adminType == 12
                                          ? [
                                                {
                                                    text: "Promociones",
                                                    onClick: promotions,
                                                },
                                            ]
                                          : []),
                                      ...(adminType == 12
                                          ? [
                                                {
                                                    text: "Gastos",
                                                    onClick: expenses,
                                                },
                                            ]
                                          : []),
                                      ...(adminType == 12
                                          ? [
                                                {
                                                    text: "Categorías de gastos",
                                                    onClick: expenseCategories,
                                                },
                                            ]
                                          : []),
                                      ...(userPermissions.includes(1001) ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Usuarios",
                                                    onClick: users,
                                                },
                                            ]
                                          : []),
                                      ...(userPermissions.includes(2028) ||
                                      userPermissions.includes("2028") ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Conciliador de pagos",
                                                    onClick:
                                                        multiPaymentProcessor,
                                                },
                                            ]
                                          : []),
                                  ],
                              },
                          ]
                        : []),
                    ...[
                        {
                            text: "Ventas",
                            items: [
                                ...(userPermissions.includes(2004) ||
                                adminType == 12
                                    ? [
                                          {
                                              text: "Pedidos",
                                              onClick: clientOrders,
                                          },
                                      ]
                                    : []),
                                ...(userPermissions.includes(2001) ||
                                adminType == 12
                                    ? [{ text: "Clientes", onClick: clients }]
                                    : []),
                                ...(userPermissions.includes(2014) ||
                                adminType == 12
                                    ? [
                                          {
                                              text: "Embudo de ventas",
                                              onClick: salesFunnel,
                                          },
                                      ]
                                    : []),
                                ...(userPermissions.includes(2003) ||
                                adminType == 12
                                    ? [
                                          {
                                              text: "Clientes por aceptar",
                                              badge: count.value,
                                              onClick: clientProspects,
                                          },
                                      ]
                                    : []),
                                ...(userPermissions.includes(2005) ||
                                adminType == 12
                                    ? [{ text: "Grupos", onClick: groups }]
                                    : []),
                                ...(userPermissions.includes(2006) ||
                                adminType == 12
                                    ? [{ text: "Rutas", onClick: routes }]
                                    : []),
                                ...(userPermissions.includes(2007) ||
                                adminType == 12
                                    ? [
                                          {
                                              text: "Segmentos",
                                              onClick: clientTypes,
                                          },
                                      ]
                                    : []),
                                ...(userPermissions.includes(2011) ||
                                adminType == 12
                                    ? [
                                          {
                                              text: "Mapa de clientes",
                                              onClick: clientsSalesMap,
                                          },
                                      ]
                                    : []),
                                ...(canAccessClientFocus
                                    ? [
                                          {
                                              text: "Enfoque de clientes",
                                              onClick: clientFocus,
                                          },
                                      ]
                                    : []),
                            ],
                        },
                    ],
                    ...(productMenuActivate || adminType == 12
                        ? [
                              {
                                  text: "Productos",
                                  items: [
                                      ...(userPermissions.includes(3000) ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Productos",
                                                    onClick: products,
                                                },
                                            ]
                                          : []),
                                      ...(userPermissions.includes(3001) ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Listas de Rango de Precio",
                                                    onClick: ranges,
                                                },
                                            ]
                                          : []),
                                      ...(userPermissions.includes(3002) ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Lineas de Producto",
                                                    onClick: productTypes,
                                                },
                                                {
                                                    text: "Datos de Producto",
                                                    onClick: productMetadata,
                                                },
                                            ]
                                          : []),
                                      ...(userPermissions.includes(3003) ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Unidades",
                                                    onClick:
                                                        productPresentations,
                                                },
                                            ]
                                          : []),
                                      ...(userPermissions.includes(3004) ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Lista de precios",
                                                    onClick: priceList,
                                                },
                                            ]
                                          : []),
                                  ],
                              },
                          ]
                        : []),
                    ...(userPermissions.includes(4000) || adminType == 12
                        ? [{ text: "Repartos", onClick: runs }]
                        : []),
                    ...(warehousesMenuActivate || adminType == 12
                        ? [
                              {
                                  text: "Almacenes",
                                  items: [
                                      {
                                          text: "Almacenes",
                                          onClick: warehouses,
                                      },
                                  ],
                              },
                          ]
                        : []),
                    ...(suppliersMenuActivate || adminType == 12
                        ? [
                              {
                                  text: "Proveedores",
                                  items: [
                                      {
                                          text: "Proveedores",
                                          onClick: suppliers,
                                      },
                                      ...(userPermissions.includes(6001) ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Ordenes de compra",
                                                    onClick: orders,
                                                },
                                            ]
                                          : []),
                                  ],
                              },
                          ]
                        : []),
                    ...(reportsMenuActivate || adminType == 12
                        ? [
                              {
                                  text: "Reportes",
                                  items: [
                                      {
                                          text: "Reporte de inventarios",
                                          onClick: inventoryReport,
                                      },
                                      ...(adminType == 12
                                          ? [
                                                {
                                                    text: "Business Intelligence",
                                                    onClick:
                                                        biMenu,
                                                },
                                            ]
                                          : []),
                                      ...(adminType == 12
                                          ? [
                                                {
                                                    text: "Reporte tridimensional",
                                                    onClick:
                                                        tridimensionalReport,
                                                },
                                            ]
                                          : []),
                                       ...(adminType == 12
                                           ? [
                                                 {
                                                     text: "Reporte de pagos",
                                                     onClick: paymentReport,
                                                 },
                                                 {
                                                     text: "Reporte de conciliación",
                                                     onClick: paymentsReconciliationReport,
                                                 },
                                             ]
                                           : []),
                                       ...(userPermissions.includes(1012) ||
                                       adminType == 12
                                           ? [
                                                 {
                                                     text: "Reporte contable de facturas",
                                                     onClick: accountingInvoicesReport,
                                                 },
                                             ]
                                           : []),
                                       ...(userPermissions.includes(1006) ||
                                       adminType == 12
                                          ? [
                                                {
                                                    text: "Reporte de ventas por producto",
                                                    onClick: sales,
                                                },
                                            ]
                                          : []),
                                      ...(userPermissions.includes(1013) ||
                                      adminType >= 11
                                          ? [
                                                {
                                                    text: "Reporte de ventas dinamico",
                                                    onClick: salesReport,
                                                },
                                            ]
                                          : []),
                                      ...(userPermissions.includes(1004) ||
                                      userPermissions.includes(1007) ||
                                      adminType == 12
                                          ? [
                                                {
                                                    text: "Reporte de clientes",
                                                    onClick: clientsReport,
                                                },
                                            ]
                                          : []),
                                       ...(userPermissions.includes(1005) ||
                                       userPermissions.includes(1009) ||
                                       adminType == 12
                                           ? [
                                                 {
                                                     text: "Reporte de cobranzas",
                                                     onClick: debts,
                                                 },
                                             ]
                                          : []),
                                  ],
                              },
                          ]
                        : []),
                    ...(userPermissions.includes(1400) || adminType >= 11
                        ? [
                              {
                                  text: "Contabilidad",
                                  onClick: accountingModule,
                              },
                          ]
                        : []),
                ];

                return filteredItems.filter((obj) => {
                    return true;
                });
            });

            const toggleSidebar = () => {
                // let temp_navbar = NAVBAR_ITEMS
                let temp_navbar = [];
                if (temp_navbar.length === 0) {
                    temp_navbar.push(...NAVBAR_ITEMS.value);
                }

                if (window.innerWidth > 1000) return; // Only run on mobile
                temp_navbar.push({
                    text: "Mi cuenta",
                    items: [
                        {
                            text: "Mis Clientes",
                            onClick: sellerClients,
                        },
                        {
                            text: "Mis Deudas",
                            onClick: debt,
                        },
                        ...(canAccessClientFocus
                            ? [{
                            text: "Enfoque de clientes",
                            onClick: clientFocus,
                        }]
                            : []),
                        {
                            text: "Ayuda",
                            onClick: tutorials,
                        },
                        {
                            text: "Cerrar Sesión",
                            onClick: logout,
                        },
                    ],
                });

                toggleSidebarP(temp_navbar);
            };

            return {
                clientOrders,
                createOrder,
                clientProspects,
                clientTypes,
                clients,
                comissions,
                clientFocus,
                debts,
                groups,
                home,
                logout,
                orders,
                ordersDebt,
                productPresentations,
                productMetadata,
                products,
                productTypes,
                ranges,
                routes,
                runs,
                sellerClients,
                suppliers,
                userName,
                debt,
                toggleSidebar,
                users,
                warehouses,
                count,
                NAVBAR_ITEMS,
                promotions,
                promotionsList,
                promotionsCreate,
                sales,
                clientsReport,
                adminType,
                userPermissions,
                priceList,
                clientsSalesMap,
                expenseCategories,
                page_title,
                canAccessClientFocus,
                tutorials,
            };
        },
    };
</script>

<style scoped>
    .ui.menu .item.mobile {
        display: none;
    }

    @media screen and (max-width: 1000px) {
        .ui.menu .item.mobile {
            display: block;
        }

        .ui.menu .item.desktop {
            display: none;
        }
    }
</style>
